import { IDataTableHeader } from '@typings/components';

export const ACCOUNTS_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Account Name', align: 'left' },
  { label: 'Type',         align: 'center' },
  { label: 'City',         align: 'left' },
  { label: 'State',        align: 'center' },
];

export const INVOICES_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Invoice Number', align: 'left' },
  { label: 'Invoice Date',   align: 'left' },
  { label: 'Status',         align: 'center' },
  { label: 'Amount',         align: 'right' },
];

export const AUCTIONS_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Auction',        align: 'left',   width: '20%' },
  { label: 'Status / VIN #', align: 'left',   width: '20%' },
  { label: 'Actions',        align: 'center', width: '15%' },
  { label: 'Watches',        align: 'center', width: '6%' },
  { label: 'Views',          align: 'center', width: '6%' },
  { label: 'Bids',           align: 'center', width: '6%' },
  { label: 'Current Bid',    align: 'center', width: '9%' },
  { label: '% WSale',        align: 'center', width: '9%' },
  { label: '% Retail',       align: 'center', width: '9%' },
];

export const SALESPERSON_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Organization Name',       align: 'left' },
  { label: 'First Name',              align: 'left' },
  { label: 'Last Name',               align: 'left' },
  { label: 'Phone',                   align: 'left' },
  { label: 'Mailing Address',         align: 'left' },
  { label: 'Email Address',           align: 'left' },
  { label: 'ACH Billing Information', align: 'left' },
];

export const USERS_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'User Name',        align: 'left' },
  { label: 'Permission Level', align: 'left' },
  { label: 'Status',           align: 'left' },
  { label: 'Last Login',       align: 'left' },
];

export const REPORTS_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Report Date', align: 'center' },
];
